import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcSuccess = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M17.4462 9.62682L10.9768 16.2922L7.15456 12.3541L8.4462 11.1004L10.9768 13.7078L16.1546 8.37317L17.4462 9.62682ZM2.40039 12C2.40039 6.53236 6.83277 2.09998 12.3004 2.09998C17.768 2.09998 22.2004 6.53236 22.2004 12C22.2004 17.4676 17.768 21.9 12.3004 21.9C6.83277 21.9 2.40039 17.4676 2.40039 12Z",
		fill: "currentColor"
	})
});
export default SvgIcSuccess;
